import { InjectionToken } from '@angular/core';
import { IRegimenService } from './regimen-service.interface';

export const REGIMEN_SERVICE = new InjectionToken<IRegimenService>(
  'REGIMEN_SERVICE'
);
